module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    ref: _vm.refName,
    staticClass: "image-upload",
    staticStyle: {
      "width": "292px",
      "height": "191px"
    },
    attrs: {
      "drag": _vm.isDrag,
      "action": _vm.action,
      "auto-upload": _vm.autoUpload,
      "multiple": _vm.isMutli,
      "on-change": _vm.loadJsonFromFile,
      "on-remove": _vm.removeInfo,
      "accept": _vm.acceptType,
      "on-exceed": _vm.handleExceed,
      "http-request": _vm.uploadFile,
      "limit": _vm.limitSize,
      "show-file-list": _vm.showFile,
      "file-list": _vm.fileList,
      "disabled": _vm.disabled
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46b23b5d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/upload-image.vue
// module id = 234
// module chunks = 1 5